/**
 * @flow
 * @relayHash 52f625a1e3a986dc6aa3f0612edc0b85
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ItemsContainer_viewer$ref = any;
export type PortfolioItemsSortByTypes = "CUSTOM" | "NET_PRICE_ASC" | "NET_PRICE_DESC" | "PRICE_ASC" | "PRICE_DESC" | "RECENTLY_CREATED" | "RECENTLY_MODIFIED" | "%future added value";
export type PortfolioTypes = "CART" | "FOLDER" | "HEART" | "PROCUREMENT" | "PROJECT" | "%future added value";
export type ItemsContainerRefetchQueryVariables = {|
  first: number,
  after?: ?string,
  hasUserId: boolean,
  portfolioTypes?: ?$ReadOnlyArray<?PortfolioTypes>,
  searchTerm?: ?string,
  loadPortfolioData: boolean,
  selectedItemIds: $ReadOnlyArray<?string>,
  sortBy?: ?PortfolioItemsSortByTypes,
  userIds: $ReadOnlyArray<?string>,
  userId: string,
  itemId: string,
  shouldFetchItem: boolean,
  showSeller: boolean,
  itemIds?: ?$ReadOnlyArray<?string>,
  shouldFetchConversation: boolean,
  shouldFetchTransaction: boolean,
  zipCode: string,
  country: string,
  canCheckZipCode: boolean,
  conversationId: string,
  hasConversationId: boolean,
  isTrade: boolean,
  page: number,
|};
export type ItemsContainerRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: ItemsContainer_viewer$ref
  |}
|};
export type ItemsContainerRefetchQuery = {|
  variables: ItemsContainerRefetchQueryVariables,
  response: ItemsContainerRefetchQueryResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasUserId",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "portfolioTypes",
    "type": "[PortfolioTypes]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "searchTerm",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "loadPortfolioData",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "selectedItemIds",
    "type": "[String]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "PortfolioItemsSortByTypes",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userIds",
    "type": "[String]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "shouldFetchItem",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "showSeller",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemIds",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "shouldFetchConversation",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "shouldFetchTransaction",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "zipCode",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "country",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "canCheckZipCode",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "conversationId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasConversationId",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isTrade",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "page",
    "type": "Int!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Literal",
  "name": "numItems",
  "value": 2,
  "type": "Int!"
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayName",
  "args": null,
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  }
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = [
  (v4/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "abbreviation",
    "args": null,
    "storageKey": null
  }
],
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId",
  "type": "String!"
},
v8 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId",
  "type": "String!"
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v10 = [
  (v6/*: any*/),
  (v9/*: any*/)
],
v11 = {
  "kind": "Literal",
  "name": "portfolioTypes",
  "value": [
    "HEART"
  ],
  "type": "[PortfolioTypes]"
},
v12 = {
  "kind": "Variable",
  "name": "userIds",
  "variableName": "userIds",
  "type": "[String]"
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "portfolioItemId",
  "args": null,
  "storageKey": null
},
v14 = [
  (v9/*: any*/),
  (v6/*: any*/)
],
v15 = {
  "kind": "Literal",
  "name": "first",
  "value": 1,
  "type": "Int"
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalResults",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v19 = [
  (v18/*: any*/)
],
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "convertedAmountList",
  "storageKey": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "plural": true,
  "selections": [
    (v18/*: any*/),
    (v20/*: any*/)
  ]
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isSold",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "handlingTimeDisplay",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "regionName",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "convertedAmountList",
  "storageKey": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "plural": true,
  "selections": [
    (v20/*: any*/),
    (v18/*: any*/)
  ]
},
v28 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }
],
v29 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId",
  "type": "String"
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "city",
  "args": null,
  "storageKey": null
},
v31 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isVerifiedTrade",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "firstValidShippingAddress",
  "storageKey": null,
  "args": null,
  "concreteType": "Address",
  "plural": false,
  "selections": (v14/*: any*/)
},
v36 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "addressBook",
  "storageKey": null,
  "args": null,
  "concreteType": "AddressBook",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "addressList",
      "storageKey": null,
      "args": null,
      "concreteType": "Address",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "line2",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "sourceId",
          "args": null,
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "formattedAddress",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayCountry",
          "args": null,
          "storageKey": null
        },
        (v33/*: any*/),
        (v34/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "line1",
          "args": null,
          "storageKey": null
        },
        (v9/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "country",
          "args": null,
          "storageKey": null
        },
        (v30/*: any*/),
        (v31/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "zipCode",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "phoneNumber",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "validation",
          "storageKey": null,
          "args": null,
          "concreteType": "AddressValidation",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "buyerShipping",
              "storageKey": null,
              "args": null,
              "concreteType": "ValidationResult",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "valid",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        },
        (v6/*: any*/)
      ]
    }
  ]
},
v37 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "tradeFirm",
  "storageKey": null,
  "args": null,
  "concreteType": "TradeFirmType",
  "plural": false,
  "selections": (v14/*: any*/)
},
v38 = [
  (v29/*: any*/),
  (v8/*: any*/)
],
v39 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isCustom",
  "args": null,
  "storageKey": null
},
v40 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "totalAmount",
  "storageKey": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "plural": false,
  "selections": [
    (v20/*: any*/),
    (v18/*: any*/),
    (v27/*: any*/)
  ]
},
v41 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "is1stdibsBilledQuote",
  "args": null,
  "storageKey": null
},
v42 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "is1stdibsWhiteGloveQuote",
  "args": null,
  "storageKey": null
},
v43 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "buyerServiceMethodDisplay",
  "args": null,
  "storageKey": null
},
v44 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "handlingTime",
  "storageKey": null,
  "args": null,
  "concreteType": "Period",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "numberOfUnits",
      "args": null,
      "storageKey": null
    }
  ]
},
v45 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "serviceMethod",
  "storageKey": null,
  "args": null,
  "concreteType": "ShipmentServiceMethod",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceMethodType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "region",
      "storageKey": null,
      "args": null,
      "concreteType": "Region",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "code",
          "args": null,
          "storageKey": null
        },
        (v26/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "regionType",
          "args": null,
          "storageKey": null
        },
        (v6/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "regionBoundary",
          "storageKey": null,
          "args": null,
          "concreteType": "RegionBoundary",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "type",
              "storageKey": null,
              "args": null,
              "concreteType": "RegionBoundaryType",
              "plural": false,
              "selections": [
                (v4/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "windowMin",
      "storageKey": null,
      "args": null,
      "concreteType": "Period",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "numberOfDays",
          "name": "numberOfUnits",
          "args": null,
          "storageKey": null
        }
      ]
    },
    (v6/*: any*/)
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ItemsContainerRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ItemsContainer_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ItemsContainerRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": "isVisuallySimilarEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "VISUALLY_SIMILAR",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"VISUALLY_SIMILAR\")"
          },
          {
            "kind": "LinkedField",
            "alias": "trendingAttributes",
            "name": "trending",
            "storageKey": "trending(numItems:2,trendType:\"ATTRIBUTE\")",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "trendType",
                "value": "ATTRIBUTE",
                "type": "TrendingTypes!"
              }
            ],
            "concreteType": "TrendingModules",
            "plural": true,
            "selections": (v3/*: any*/)
          },
          {
            "kind": "ScalarField",
            "alias": "onlyTradeRequestsQuote",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "useOldPdpShippingModals",
                "type": "String!"
              }
            ],
            "storageKey": "isEnabled(key:\"useOldPdpShippingModals\")"
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "geography",
            "storageKey": null,
            "args": null,
            "concreteType": "Geography",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "countries",
                "storageKey": null,
                "args": null,
                "concreteType": "GeographyObject",
                "plural": true,
                "selections": (v5/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "usStates",
                "storageKey": null,
                "args": null,
                "concreteType": "GeographyObject",
                "plural": true,
                "selections": (v5/*: any*/)
              }
            ]
          },
          (v6/*: any*/),
          {
            "kind": "LinkedField",
            "alias": "trendingCategories",
            "name": "trending",
            "storageKey": "trending(categoryLevels:3,numItems:2,trendType:\"CATEGORY\")",
            "args": [
              {
                "kind": "Literal",
                "name": "categoryLevels",
                "value": 3,
                "type": "Int"
              },
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "trendType",
                "value": "CATEGORY",
                "type": "TrendingTypes!"
              }
            ],
            "concreteType": "TrendingModules",
            "plural": true,
            "selections": (v3/*: any*/)
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "shouldFetchConversation",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "buyerItemConversation",
                "storageKey": null,
                "args": [
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "concreteType": "Conversation",
                "plural": false,
                "selections": (v10/*: any*/)
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "loadPortfolioData",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "heartItemMatches",
                "name": "portfolioItemMatches",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "itemIds",
                    "variableName": "selectedItemIds",
                    "type": "[String]"
                  },
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "concreteType": "PortfolioItemV2",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "portfolioId",
                    "args": null,
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "item",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Item",
                    "plural": false,
                    "selections": (v14/*: any*/)
                  },
                  (v6/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "userPortfolios",
                "name": "portfolios",
                "storageKey": null,
                "args": [
                  (v15/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "concreteType": "PortfoliosConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfoliosEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioV2",
                        "plural": false,
                        "selections": (v14/*: any*/)
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "itemsPortfolios",
                "name": "portfolios",
                "storageKey": null,
                "args": [
                  (v15/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "portfolioTypes",
                    "variableName": "portfolioTypes",
                    "type": "[PortfolioTypes]"
                  },
                  (v12/*: any*/)
                ],
                "concreteType": "PortfoliosConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfoliosEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioV2",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isPublic",
                            "args": null,
                            "storageKey": null
                          },
                          (v9/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": "totalPortfolioItems",
                            "name": "items",
                            "storageKey": "items(first:1)",
                            "args": [
                              (v15/*: any*/)
                            ],
                            "concreteType": "PortfolioItemsConnection",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "after",
                                "variableName": "after",
                                "type": "String"
                              },
                              {
                                "kind": "Variable",
                                "name": "first",
                                "variableName": "first",
                                "type": "Int"
                              },
                              {
                                "kind": "Variable",
                                "name": "page",
                                "variableName": "page",
                                "type": "Int"
                              },
                              {
                                "kind": "Variable",
                                "name": "searchTerm",
                                "variableName": "searchTerm",
                                "type": "String"
                              },
                              {
                                "kind": "Variable",
                                "name": "sortBy",
                                "variableName": "sortBy",
                                "type": "PortfolioItemsSortByTypes"
                              }
                            ],
                            "concreteType": "PortfolioItemsConnection",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "numberOfPages",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "pageInfo",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PageInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hasNextPage",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "endCursor",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PortfolioItemsEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "cursor",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PortfolioItemV2",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "item",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Item",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "creators",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ItemCreator",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "creator",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "Creator",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*: any*/),
                                                  (v6/*: any*/)
                                                ]
                                              },
                                              (v6/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "attribution",
                                                "args": null,
                                                "storageKey": null
                                              }
                                            ]
                                          },
                                          (v9/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "seller",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Seller",
                                            "plural": false,
                                            "selections": [
                                              (v9/*: any*/),
                                              (v6/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "sellerProfile",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "SellerProfile",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "company",
                                                    "args": null,
                                                    "storageKey": null
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v6/*: any*/),
                                          (v17/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "firstPhotoWebPath",
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "size",
                                                "value": "large",
                                                "type": "ImageVersionTypeName!"
                                              }
                                            ],
                                            "storageKey": "firstPhotoWebPath(size:\"large\")"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "contemporaryTrackingString",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "categoryPath",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "pricing",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ItemPricing",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "retailPrice",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "FinancialAmount",
                                                "plural": false,
                                                "selections": (v19/*: any*/)
                                              },
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "totalAmount",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "FinancialAmount",
                                                "plural": false,
                                                "selections": [
                                                  (v20/*: any*/)
                                                ]
                                              },
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "prices",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "Price",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "amount",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "FinancialAmount",
                                                    "plural": false,
                                                    "selections": [
                                                      (v18/*: any*/),
                                                      (v21/*: any*/)
                                                    ]
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "pricePerPiece",
                                                    "args": null,
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "hidePrice",
                                                    "args": null,
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "negotiable",
                                                    "args": null,
                                                    "storageKey": null
                                                  },
                                                  (v22/*: any*/),
                                                  (v23/*: any*/)
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "quickViewDisplay",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "QuickViewDisplayType",
                                            "plural": false,
                                            "selections": [
                                              (v17/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "alias": "mobileTitle",
                                                "name": "title",
                                                "args": [
                                                  {
                                                    "kind": "Literal",
                                                    "name": "formatType",
                                                    "value": "MOBILE",
                                                    "type": "formatTitleTypes"
                                                  }
                                                ],
                                                "storageKey": "title(formatType:\"MOBILE\")"
                                              },
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "paragraphs",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "QuickViewParagraph",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "key",
                                                    "args": null,
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "text",
                                                    "args": null,
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": "mobileText",
                                                    "name": "text",
                                                    "args": [
                                                      {
                                                        "kind": "Literal",
                                                        "name": "formatType",
                                                        "value": "MOBILE",
                                                        "type": "formatTextTypes"
                                                      }
                                                    ],
                                                    "storageKey": "text(formatType:\"MOBILE\")"
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "localizedPdpUrl",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "isArt",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "classification",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ItemClassification",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "creationDate",
                                                "args": null,
                                                "storageKey": null
                                              }
                                            ]
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "vertical",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "canMultipleQuantityBePurchased",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "isOnHold",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          (v24/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "hasRequestedHoldForBuyer",
                                            "args": [
                                              (v7/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "activeHold",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Hold",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "expirationDate",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              (v6/*: any*/)
                                            ]
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "shipmentQuotes",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ShipmentQuote",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "isLocalPickup",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "isComplimentary",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              (v25/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "serviceMethod",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "ShipmentServiceMethod",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*: any*/),
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "region",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Region",
                                                    "plural": false,
                                                    "selections": [
                                                      (v26/*: any*/),
                                                      (v6/*: any*/)
                                                    ]
                                                  },
                                                  (v6/*: any*/)
                                                ]
                                              },
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "totalAmount",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "FinancialAmount",
                                                "plural": false,
                                                "selections": [
                                                  (v27/*: any*/),
                                                  (v18/*: any*/)
                                                ]
                                              },
                                              (v6/*: any*/)
                                            ]
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "isCustomizable",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "isMultiSku",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "displayPrice",
                                            "storageKey": null,
                                            "args": [
                                              {
                                                "kind": "Variable",
                                                "name": "isTrade",
                                                "variableName": "isTrade",
                                                "type": "Boolean"
                                              },
                                              {
                                                "kind": "Literal",
                                                "name": "page",
                                                "value": "searchAndBrowse",
                                                "type": "PageDisplayEnum"
                                              }
                                            ],
                                            "concreteType": "ItemDisplayPriceType",
                                            "plural": true,
                                            "selections": [
                                              (v21/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "quantityDisplay",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "percentageOff",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              (v22/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "showPriceLabel",
                                                "args": null,
                                                "storageKey": null
                                              }
                                            ]
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": "productPhotos",
                                            "name": "photos",
                                            "storageKey": "photos(limit:1)",
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "limit",
                                                "value": 1,
                                                "type": "Int"
                                              }
                                            ],
                                            "concreteType": "ItemPhoto",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "placeholder",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "smallPath",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "versions",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "ItemPhotoVersion",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "webPath",
                                                    "args": null,
                                                    "storageKey": null
                                                  }
                                                ]
                                              },
                                              (v6/*: any*/)
                                            ]
                                          },
                                          {
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "condition": "hasUserId",
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": "tilesProjects",
                                                "name": "projects",
                                                "storageKey": null,
                                                "args": (v28/*: any*/),
                                                "concreteType": "Project",
                                                "plural": true,
                                                "selections": [
                                                  (v4/*: any*/),
                                                  (v9/*: any*/),
                                                  (v6/*: any*/)
                                                ]
                                              },
                                              {
                                                "kind": "LinkedField",
                                                "alias": "pdpDisplayInfo",
                                                "name": "displayInfo",
                                                "storageKey": null,
                                                "args": [
                                                  (v29/*: any*/),
                                                  {
                                                    "kind": "Literal",
                                                    "name": "page",
                                                    "value": "pdp",
                                                    "type": "PageDisplayEnum"
                                                  }
                                                ],
                                                "concreteType": "ItemDisplayInfo",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "pricing",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PriceInfoDisplay",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "showRetail",
                                                        "args": null,
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "showNet",
                                                        "args": null,
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "showSale",
                                                        "args": null,
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "showPUR",
                                                        "args": null,
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "showSold",
                                                        "args": null,
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "showOnHold",
                                                        "args": null,
                                                        "storageKey": null
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v6/*: any*/),
                                      (v13/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "note",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "canCheckZipCode",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "zipCodeLookUp",
                "name": "zipCode",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "country",
                    "variableName": "country",
                    "type": "String!"
                  },
                  {
                    "kind": "Variable",
                    "name": "zipCode",
                    "variableName": "zipCode",
                    "type": "String!"
                  }
                ],
                "concreteType": "Address",
                "plural": true,
                "selections": [
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v6/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v28/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v32/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "profile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Profile",
                    "plural": false,
                    "selections": [
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v20/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "email",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  (v9/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "relevantShippingInfo",
                "storageKey": null,
                "args": (v38/*: any*/),
                "concreteType": "QueryRelevantShippingInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shipmentQuote",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ShipmentQuote",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "subTotalAmount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": (v19/*: any*/)
                      },
                      (v39/*: any*/),
                      (v6/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "projects",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 200,
                    "type": "Int"
                  },
                  (v12/*: any*/)
                ],
                "concreteType": "ProjectConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ProjectEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Project",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "portfolio",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PortfolioV2",
                            "plural": false,
                            "selections": (v14/*: any*/)
                          },
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "shouldFetchItem",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "item",
                "storageKey": null,
                "args": [
                  (v8/*: any*/)
                ],
                "concreteType": "Item",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v24/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "seller",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Seller",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "Condition",
                        "passingValue": true,
                        "condition": "hasUserId",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "favoritesByUser",
                            "storageKey": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "userIds",
                                "variableName": "userId",
                                "type": "String!"
                              }
                            ],
                            "concreteType": "Favorite",
                            "plural": true,
                            "selections": (v14/*: any*/)
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasPreQuotedShipping",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "itemIsOnHold",
                    "name": "isOnHold",
                    "args": [
                      (v29/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "address",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Address",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": "itemAddress",
                        "name": "displayCityStateCountry",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "fullCountryName",
                            "value": true,
                            "type": "Boolean"
                          }
                        ],
                        "storageKey": "displayCityStateCountry(fullCountryName:true)"
                      },
                      (v6/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "relevantShippingInfo",
                "storageKey": null,
                "args": (v38/*: any*/),
                "concreteType": "QueryRelevantShippingInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shipment",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Shipment",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "shippingAddress",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Address",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "displayCityStateCountry",
                            "args": null,
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ]
                      },
                      (v6/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shipmentQuote",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ShipmentQuote",
                    "plural": false,
                    "selections": [
                      (v40/*: any*/),
                      (v39/*: any*/),
                      (v41/*: any*/),
                      (v42/*: any*/),
                      (v25/*: any*/),
                      (v9/*: any*/),
                      (v43/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "buyerSubTotalAmount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": [
                          (v27/*: any*/)
                        ]
                      },
                      (v6/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipmentQuotes",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10,
                    "type": "Int"
                  },
                  {
                    "kind": "Variable",
                    "name": "itemId",
                    "variableName": "itemId",
                    "type": "String"
                  },
                  {
                    "kind": "Literal",
                    "name": "searchView",
                    "value": "IGNORE_LOCAL_PICKUP",
                    "type": "SearchView"
                  }
                ],
                "concreteType": "ShipmentQuotesConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ShipmentQuotesEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShipmentQuote",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v41/*: any*/),
                          (v42/*: any*/),
                          (v25/*: any*/),
                          (v40/*: any*/),
                          (v43/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "buyerSubTotalAmount",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v27/*: any*/)
                            ]
                          },
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasConversationId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "conversation",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "conversationId",
                    "variableName": "conversationId",
                    "type": "ID!"
                  }
                ],
                "concreteType": "Conversation",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "transaction",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Transaction",
                    "plural": false,
                    "selections": (v10/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "originalBuyer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ConversationMember",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "User",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "profile",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Profile",
                            "plural": false,
                            "selections": [
                              (v33/*: any*/),
                              (v34/*: any*/)
                            ]
                          },
                          (v32/*: any*/),
                          (v9/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v6/*: any*/)
                        ]
                      },
                      (v6/*: any*/)
                    ]
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "shouldFetchTransaction",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "transactions",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds",
                    "type": "[String]"
                  },
                  (v15/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "itemId",
                    "variableName": "itemIds",
                    "type": "[String]"
                  },
                  {
                    "kind": "Literal",
                    "name": "sort",
                    "value": "createdDate desc",
                    "type": "String"
                  },
                  {
                    "kind": "Literal",
                    "name": "viewName",
                    "value": "mc.conversationTransaction",
                    "type": "String"
                  }
                ],
                "concreteType": "TransactionConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TransactionEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Transaction",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v9/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isCanceled",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasCompletedCheckout",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "lastShipmentQuote",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ShipmentQuote",
                            "plural": false,
                            "selections": [
                              (v23/*: any*/),
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ItemsContainerRefetchQuery",
    "id": "app-buyer-misc/209.0.0-2019-03-26T14:04:46.491Z/ItemsContainerRefetchQuery",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bdcd6fbea8292c68f885d510abe5e602';
module.exports = node;
